import { stateMe } from '$states/me.svelte';
import { Guard, type GuardRun } from '../utils/Guard';

export class RequireUsername extends Guard implements GuardRun {
  run() {
    if (
      this.target.includes('/welcome') ||
      this.target.includes('/p/') ||
      this.target.includes('/migrate')
    ) {
      return;
    }

    if (this.target.length > 1 && !stateMe.current?.name) {
      return this.redirectTo('/migrate/enter-details');
    }
  }
}
